import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["explanation"]

  reasonSelected() {
    let reason = document.querySelector('input[name="cancellation_reason[reason]"]:checked').value

    // When the "other" radio button is selected, enforce the explanation field to be required
    if (reason === "other") {
      this.explanationTarget.setAttribute("required", true)
    } else {
      this.explanationTarget.removeAttribute("required")
    }
  }
}
